// More attributes can be added to this object as needed
// to more easily prepare thoe download method.
export const ACCOUNTS_REPORT = {
    id_type: 34,
};

export const REMUNERATED_REPORT = {
    id_type: 53,
};
